'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getErrorMessage = require('./get-error-message');
var _getErrorMessage2 = _interopRequireDefault(_getErrorMessage);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
exports.default = function () {
  var errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Please enter a valid email';
  return function (value, values) {
    return emailRegex(value) ? '' : (0, _getErrorMessage2.default)(errorMessage, {
      value: value
    });
  };
};
function emailRegex(email) {
  var re = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
  return typeof email === 'string' && re.test(email.toLowerCase());
}